import { IDataProviderFilter, IFilter, Logic } from 'core-components/types'

import { isDataProviderFilter, isFilter } from '../common'

export const findFilterItem = (filter: IDataProviderFilter, field: string) =>
  filter.filters.find((i) => isFilter(i) && i.field === field) as IFilter | undefined

export const findSubFiltersByLogic = (filter: IDataProviderFilter, logic: Logic) => {
  return filter.filters.filter(
    (i) => isDataProviderFilter(i) && i.logic === logic
  ) as IDataProviderFilter[]
}

// mutates filter.filters
export const exceptField = (filter: IDataProviderFilter, field: string) => {
  filter.filters = filter.filters.filter((i) => !isFilter(i) || i.field !== field)
}
